import styled from 'styled-components';

export const Image = styled.img`
  display: block;
  width: 100%;
  border-radius: var(--image-border-radius, 3px);
`;
